import { useMemo } from 'react';
import { DemographicsDataProviders } from '~/store/demographics/demographics.types';
import { useActivePremiumDemographicsSelector } from '~/store/demographics/premiumDemographics/demographicsListPremium.selectors';
import { usePremiumDemographicsList } from '~/store/demographics/premiumDemographics/usePremiumDemographicsList';
import { useMapSettingsActiveDataLayerGroupSelector } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.selectors';
import { type MetricModel } from '../metrics.factory';
import { getDataLayersMetrics } from './dataLayersMetrics.helpers';

export const useDataLayersMetrics = (): ReadonlyArray<MetricModel> => {
  const layer = useMapSettingsActiveDataLayerGroupSelector();
  const { agsData } = usePremiumDemographicsList();
  const { accessible } = useActivePremiumDemographicsSelector(DemographicsDataProviders.AGS);

  return useMemo(() => getDataLayersMetrics(layer?.data, agsData, accessible), [layer, agsData, accessible]);
};
